import React from 'react'
import { Edit } from '@mui/icons-material'
import Dinero from 'dinero.js'
import store from 'state/store'
import EditableCell from 'components/generic/datagrid/cells/EditableCell'
import InputFormat from 'components/generic/inputs/formatting/InputFormat'
import { setDecimalPrecision } from 'utils/helpers'

export function getValidationError(validateFn) {
  let error
  try {
    validateFn()
  } catch (e) {
    error = e
  }
  return error
}

export function getColumns(control, setValue, schema, isEdit) {
  const state = store.getState()
  const decimalPrecisionSetting = state?.settings?.settings?.purchaseSettings?.inboundTickets?.decimalPrecision || 2

  const getErrorFn = fieldName => val =>
    getValidationError(() => schema.validateSyncAt(fieldName, { [fieldName]: val }))
  const getOnChangeFn = name => event => setValue(name, event.target.value)
  const commonProps = { control, isEdit }
  return [
    {
      field: 'name',
      headerName: 'Benchmark Name',
      flex: 1,
      renderCell: params => {
        const id = params.row?.id
        const fieldName = 'name'
        const name = `${id}.${fieldName}`
        const value = params.row?.name
        return (
          <EditableCell
            {...commonProps}
            name={name}
            defaultValue={value}
            onChange={getOnChangeFn(name)}
            getError={getErrorFn(fieldName)}
            variant="standard"
            placeholder="Name"
          />
        )
      },
    },
    {
      field: 'publication',
      headerName: 'Publication',
      flex: 1,
      renderCell: params => {
        const id = params.row?.id
        const fieldName = 'publication'
        const name = `${id}.${fieldName}`
        const value = params.row?.publication
        return (
          <EditableCell
            {...commonProps}
            name={name}
            defaultValue={value}
            onChange={getOnChangeFn(name)}
            getError={getErrorFn(fieldName)}
            variant="standard"
            placeholder="Publication"
          />
        )
      },
    },
    {
      field: 'price',
      headerName: 'Price',
      flex: 1,
      headerAlign: 'right',
      align: 'right',
      renderCell: params => {
        const id = params.row?.id
        const fieldName = 'price'
        const name = `${id}.${fieldName}`
        const value = Dinero({ ...(params.row?.price || {}) }).toUnit()
        if (!isEdit) {
          return `$${setDecimalPrecision(value)}`
        }
        return (
          <EditableCell
            {...commonProps}
            name={name}
            defaultValue={value}
            variant="standard"
            getError={getErrorFn(fieldName)}
            InputProps={{
              inputComponent: InputFormat,
              inputProps: {
                inputType: 'price',
                fixedDecimalScale: true,
                decimalScale: decimalPrecisionSetting,
                onChange: getOnChangeFn(name),
                style: {
                  textAlign: 'right',
                },
              },
            }}
          />
        )
      },
    },
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
    },
  ]
}

export function getButtons({ isEdit, onHideModal, setIsEdit }) {
  if (isEdit) {
    return [
      {
        id: 'submit-benchmarks-button',
        text: 'Save Changes',
        type: 'submit',
        variant: 'contained',
      },
      {
        id: 'exit-benchmarks-button',
        text: 'Cancel',
        onClick: () => onHideModal(),
      },
    ]
  }
  return [
    {
      id: 'edit-benchmarks-button',
      text: (
        <>
          <Edit /> Edit
        </>
      ),
      onClick: () => setIsEdit(true),
    },
    {
      id: 'exit-benchmarks-button',
      text: 'Cancel',
      onClick: () => onHideModal(),
    },
  ]
}
